/* eslint-disable no-empty-pattern */
import React, { useMemo, useContext, useEffect, useState } from 'react'
import CommonVideoCard from '../common-video-card'
import CommonLiveItem from './item'
import {
  ILiveRoomItem,
  ILiveBrandItem,
  getLiveRoomList,
  getLiveTabsList,
} from '../../services/home'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'array-flat-polyfill'
import { useResponsive } from 'Components/hooks/use-responsive'
import { GlobalStoreContext } from 'Components/store'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { useInView } from 'react-intersection-observer'
import dynamic from 'next/dynamic'
import LongItem from './longItem'
import { ResponsiveConfig } from 'Components/new/responsive-swiper'
import { unstable_batchedUpdates } from 'react-dom'
import useLazyRender from 'Components/hooks/use-lazy-render'

interface ILiveTabs {
  has_kol: boolean
  has_local: boolean
  brands: ILiveBrandItem[]
}
interface IProps {
  data?: ILiveRoomItem[]
  liveTabs?: ILiveTabs
}

const cols: ResponsiveConfig = {
  sm: 4,
  md: 4,
  lg: 4,
  xl: 4,
  '2xl': 5,
}

const rows: ResponsiveConfig = {
  sm: 2,
  md: 2,
  lg: 2,
  xl: 2,
  '2xl': 2,
}

const renderSlider = (item: any, order: number, activeIndex: number) => {
  // const perViewItemsCount =
  //   (breakPoint?.slidesPerView || 1) * (breakPoint?.slidesPerColumn || 1)

  return item ? (
    <CommonLiveItem order={order} activeIndex={activeIndex} data={item} />
  ) : null
}

const HomeLive: React.FC<IProps> = ({}) => {
  const [data, setData] = useState<ILiveRoomItem[]>(null!)
  const [liveTabs, setLiveTabs] = useState<ILiveTabs>(null!)
  // const responsive = useResponsive()
  const { state: globalStore, dispatch } = useContext(GlobalStoreContext)
  // const [ref, inView] = useInView({
  //   threshold: 0,
  // })
  // useEffect(() => {
  //   if (inView) {
  //     sendTeaCommEvent('show_event', {
  //       page_id: 'page_main_new',
  //       event_id: 'common_conponent_module',
  //       module_id: 'live_module',
  //     })
  //   }
  // }, [inView])

  useEffect(() => {
    async function init() {
      const data = await Promise.all([
        getLiveRoomList(null, globalStore.cityName, globalStore.cityName),
        getLiveTabsList(null),
      ])
      unstable_batchedUpdates(() => {
        setData(
          data?.[0]?.filter((item: ILiveRoomItem) => item.type === 'common')
        )
        setLiveTabs(data?.[1])
      })
    }
    init()
  }, [globalStore.cityName])

  // 小于7由于排版问题，不展示直播楼层
  if (!data || data?.length < 7) {
    return null
  }

  //const liveTop = data?.find(item => item.type === 'top');
  const liveTop = null //先下掉top
  const liveCommons = data

  // const getTabs = () => {
  //   let brands = []
  //   if (liveTabs?.has_local) {
  //     brands.push({
  //       link: `/live?brand=local`,
  //       label: '本地',
  //     })
  //   }
  //   if (liveTabs?.has_kol) {
  //     brands.push({
  //       link: `/live?brand=kol`,
  //       label: '大咖',
  //     })
  //   }
  //   brands = brands.concat(
  //     liveTabs?.brands?.map((item) => ({
  //       link: `/live?brand=${item?.brand_id}`,
  //       label: item?.brand_name,
  //       icon: item?.logo,
  //     })) || []
  //   )
  //
  //   if (brands?.length) {
  //     if (responsive?.['2xl'] && brands?.length > 15) {
  //       brands.length = 15
  //     } else if (responsive?.['xl'] && brands?.length > 12) {
  //       brands.length = 12
  //     } else if (responsive?.['lg'] && brands?.length > 11) {
  //       brands.length = 11
  //     } else if (responsive?.['md'] && brands?.length > 9) {
  //       brands.length = 9
  //     } else if (responsive?.['sm'] && brands?.length > 7) {
  //       brands.length = 7
  //     } else {
  //       brands.length = 7
  //     }
  //   }
  //
  //   return brands
  // }

  // const liveTopElement = liveTop ? (
  //   <div className="tw-col-span-3 xl:tw-col-span-2">
  //     <LongItem data={liveTop} />
  //   </div>
  // ) : null

  let sliderWrapClassName = 'tw-col-span-10 xl:tw-col-span-8'
  if (!liveTop) {
    sliderWrapClassName = 'tw-col-span-40'
  }

  return (
    <div
      className="home-live-card fix-swiper-hover-overflow tw-mt-16 fix-swiper-mutil-row-mt-16"
      // ref={ref}
      data-log-view-config={JSON.stringify({
        repeated: true,
      })}
      data-log-view={JSON.stringify({
        event: 'show_event',
        params: {
          page_id: 'page_main_new',
          event_id: 'common_conponent_module',
          module_id: 'live_module',
        },
      })}
    >
      <CommonVideoCard
        list={liveCommons}
        titleObj={{
          link: '/live',
          label: '直播聊车',
        }}
        onTitleClick={() => {
          sendTeaCommEvent('clk_event', {
            page_id: 'page_main_new',
            event_id: 'live_module_title',
            module_id: 'live_module',
          })
        }}
        onNavItemClick={(item) => {
          sendTeaCommEvent('clk_event', {
            page_id: 'page_main_new',
            event_id: 'live_module_keywords',
            module_id: 'live_module',
            button_name: item.label,
          })
        }}
        // beforeRenderSlider={liveTopElement}
        sliderWrapClassName={sliderWrapClassName}
        renderSlider={renderSlider}
        narrowScreenItemSize={liveTop ? 6 : 8}
        wideScreenItemSize={liveTop ? 8 : 10}
        swiperConfig={{
          slidesPerGroup: liveTop ? 3 : 4,
          slidesPerView: liveTop ? 3 : 4,
          spaceBetween: 12,
          slidesPerColumn: 2,
          slidesPerColumnFill: 'row',
          onSlideChange: () => {
            sendTeaCommEvent('clk_event', {
              page_id: 'page_main_new',
              event_id: 'live_module_change',
              module_id: 'live_module',
            })
          },
          breakpoints: {
            1920: {
              spaceBetween: 12,
              slidesPerView: liveTop ? 4 : 5,
              slidesPerGroup: liveTop ? 4 : 5,
              slidesPerColumn: 2,
              slidesPerColumnFill: 'row',
            },
          },
        }}
        cols={cols}
        rows={rows}
        slideClass="tw-w-2.5 2xl:tw-w-2/10"
      />
    </div>
  )
}

export default HomeLive
